import { GET_TICKETS_AVAILABILITY_SUCCESS, GET_TICKETS_SUCCESS } from './types';

import { isValidPurchaseDates } from '../../lib/dates';

const initialState = {};

/**
 * Merges ticket event state
 *
 * @param {Object[]} state events state
 * @param {Object[]} events events
 * @returns {Object[]} state
 */
const mergeTicketEvents = (state = [], events) => [
  ...state,
  ...events.map(event => ({
    ...event,
    tickets: event.tickets.filter(
      ({ offline, purchase_start_date, purchase_end_date }) =>
        !offline &&
        isValidPurchaseDates(purchase_start_date, purchase_end_date),
    ),
  })),
];

/**
 * Merges availability data into tickets
 *
 * @param {Object[]} state events state
 * @param {Object[]} availability availability data
 * @returns {Object[]} state
 */
const mergeTicketAvailability = (state = [], availability) =>
  state.map(event => ({
    ...event,
    tickets: event.tickets
      .map(ticket => ({
        ...ticket,
        availability: availability.find(({ id }) => id === ticket.id) ?? {},
      }))
      .filter(ticket => Object.entries(ticket.availability).length > 0),
  }));

const ticketsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TICKETS_SUCCESS:
      return {
        ...state,
        events: mergeTicketEvents([], action.payload.events),
      };
    case GET_TICKETS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        ticketsAvailability: action.payload.tickets,
        events: mergeTicketAvailability(state.events, action.payload.tickets),
      };
    default:
      return state;
  }
};

export default ticketsReducer;
